'use client';
import { responsiveModifierSet, isValidStyleProperty, isResponsiveModifier, getKey } from './swan-style.utils.js';
import { iterToSet } from './transform.utils.js';

function getClassName(s, t, l = 'xs') {
    if (null == t) return null;
    let r = getKey(s);
    if (!r) return null;
    let n = `swan-${r}`, o = 'xs' === l ? '' : `-${l}`;
    return 'boolean' == typeof t ? t ? n + o : null : n + `-${t}` + o;
}
function updateClassNameSet(e, s, t, l) {
    let r = getClassName(e, s, t);
    return r && l.add(r), l;
}
function processResponsiveStyleProps(e, l, r = new Set()) {
    return Object.keys(e).forEach((n)=>{
        if (!isValidStyleProperty(n)) return null;
        if ('object' == typeof e[n]) {
            let t = e[n];
            Object.keys(t).forEach((e)=>{
                isResponsiveModifier(e) && updateClassNameSet(n, t[e], e, r);
            });
        } else updateClassNameSet(n, e[n], l, r);
    }), r;
}
function processStyleProps(e, s) {
    let t = iterToSet(s);
    if (e.swanStyle) {
        let s = e.swanStyle;
        responsiveModifierSet.forEach((e)=>{
            let l = s[e];
            l && (t = processResponsiveStyleProps(l, e, t));
        }), t = processResponsiveStyleProps(e.swanStyle, 'xs', t);
    }
    return processResponsiveStyleProps(e, 'xs', t), t;
}

export { processStyleProps };
